import "./App.css";
import { Routes, Route, HashRouter } from "react-router-dom";
import Homepage from "./Pages/Homepage/Homepage";
import Directory from "./Pages/Directory/Directory";
import About from "./Pages/About/About";
import Header from "./components/Header";
import NotFound from "./Pages/404/NotFound";

import Landmark from "./Pages/Landmark/Landmark";
import { RecoilRoot } from "recoil";
import { translationMessages } from "./i18n";
import { IntlProvider } from "react-intl";
import { useState } from "react";
import { MapDataProvider } from "./mapData/MapDataProvider";

function App() {
  const [locale, setLocale] = useState("zh");
  const changeLocale = () => {
    const newLocale = locale === "en" ? "zh" : "en";
    localStorage.setItem("selectedLanguage", newLocale);
    setLocale(newLocale);
  };

  return (
    <IntlProvider
      messages={translationMessages[locale]}
      locale={locale}
      defaultLocale={"en"}
    >
      <MapDataProvider>
        <RecoilRoot>
          <HashRouter>
            <Header changeLocale={changeLocale} />
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Homepage />} />
              <Route path="/about" element={<About />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/directory/:id" element={<Landmark />} />
            </Routes>
          </HashRouter>
        </RecoilRoot>
      </MapDataProvider>
    </IntlProvider>
  );
}

export default App;
